import { FunctionComponent } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import router from './router';
import { createGlobalStyle, useTheme } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
	min-height: 100vh;
	margin: 0;
	padding: 0;
	scroll-behavior: smooth;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-rendering: optimizeSpeed;
    background: ${({ theme }) => theme.colors.bgPageBody};
  }

  body, button, select, input, textarea, code, tt, pre {
	font-family: ${({ theme }) =>
		`${theme.typography.family.sansSerif}, sans-serif`};
  }
`;

const App: FunctionComponent = () => {
	const { typography } = useTheme();

	return (
		<HelmetProvider>
			<GlobalStyle />
			<Helmet>
				<title>Account Admin | Montel</title>
				<meta name="description" content="Account Admin application" />
				<link href={typography.fontSource} rel="stylesheet" />
			</Helmet>
			<RouterProvider router={router} />
			<ToastContainer
				position="bottom-right"
				hideProgressBar
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
		</HelmetProvider>
	);
};

export default App;
